export const WhiteboardKeys = {
  // 主题色, 影响选中框的颜色
  themeColor: 'themeColor',
  // 当前显示的白板页
  currentPage: 'currentPage',
  selectElements: 'selectElements',
  viewMatrix: 'viewMatrix',
  cameraMode: 'cameraMode'
};